<template>
	<BannerHighlightForm
		:is-loading="isLoading"
		:banner-type="bannerType"
		@onSubmit="handleSubmit"
	/>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import BannerHighlightForm from '@/components/BannerHighlightForm.vue';

import { BANNER_TYPE } from '../enums/banners';
import { scrollToTop } from '../assets/js/helpers';

export default {
	name: 'BannerHighlightCreate',

	components: {
		BannerHighlightForm,
	},

	props: {
		bannerType: {
			type: String,
			default: BANNER_TYPE.highlight,
		},
	},

	computed: {
		...mapState('banners', {
			create: 'create',
		}),

		isLoading() {
			return this.create.isLoading;
		},
	},

	methods: {
		...mapActions({
			showToast: 'toast/showToast',
			createBannerGroup: 'banners/createBannerGroup',
		}),

		async handleSubmit(data) {
			try {
				await this.createBannerGroup(data);

				this.$router.push({ name: 'BannerHighlightList' });
			} catch {
				scrollToTop();
			}
		},
	},
};
</script>
